import React from 'react'
import ReactDOM from 'react-dom'
import { applyMiddleware, compose, createStore } from 'redux'
import ReduxThunk from 'redux-thunk'
import { Provider } from 'react-redux'
import { ConnectedRouter, connectRouter, routerMiddleware } from 'connected-react-router'
import { TranslationProvider, GetBrowserLanguageCode } from 'react-translatify'
import createSagaMiddleware from 'redux-saga'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import MomentUtils from '@date-io/moment'
import googleAnalyticsMiddleware from './analytics/googleAnalyticsMiddleware'
import kitfitAnalyticsMiddleware from './analytics/kitfitAnalyticsMiddleware'
import addAppErrorLogEntry from './dataservices/addAppErrorLogEntry'
//	NOTE: Must grab the history from external file, or it can sometimes be regenerated (via WebPack), causing an error: "browser.js:49 Warning: You cannot change <Router history>"
import history from './utilities/CreateHistory'
import App from './App'
//	Fonts ref: https://stackoverflow.com/a/41255971/6637365
import '../dist/fonts/roboto/index.css'
import settings from '../config/settings'
import './index.css'
import muiTheme from './muiTheme'
import rootReducer from './redux/reducers'
import logger from './redux/middleware/logger'
import reporter from './redux/middleware/reporter'
import rootSaga from './redux/saga'

import ScrollToTop from './components/ScrollToTop'

//	TODO: Use fetch call to load language translations on demand.
import da from '../dist/translate/translations.da.json'

//	Grab all our translations based on browser language code.
const languageCode = GetBrowserLanguageCode()
const translations = { da }
const sagaMiddleware = createSagaMiddleware({
	onError: (err) => {
		const entry = Object.assign({}, err.details)
		addAppErrorLogEntry(entry.action, entry.data, entry.details, entry.type)
	}
})

//	Note: Thunk should always be first, as other middleware expect "normal" reduxy stuff...
const middleWares = [ReduxThunk, routerMiddleware(history), sagaMiddleware]

if (!settings.options.disableReporter) {
	middleWares.push(reporter)
}
if (!settings.options.disableKitfitAnalytics) {
	middleWares.push(kitfitAnalyticsMiddleware)
}
if (!settings.options.disableGoogleAnalytics) {
	middleWares.push(googleAnalyticsMiddleware)
}

const overrideEnableLogging = global.localStorage.getItem('enableLogger')
let replay = () => {}
const showLogs = (overrideEnableLogging === 'true' || settings.options.enableLogger) && overrideEnableLogging !== 'false'
const loggerInstance = logger({ showLogs })
replay = loggerInstance.replay
middleWares.push(loggerInstance.middleware)

if (settings.options.enableDebug) {
	const debugMiddleware = store => next => (action) => {
		global.KF = {
			...global.KF,
			store,
			enableLogger: (isEnabled) => {
				global.localStorage.setItem('enableLogger', !!isEnabled)
			},
			replay
		}
		return next(action)
	}
	middleWares.push(debugMiddleware)
}

//	Create our store
const store = createStore(
	connectRouter(history)(rootReducer),
	// initialState,
	compose(
		applyMiddleware(...middleWares)
	)
)

sagaMiddleware.run(rootSaga)

ReactDOM.render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<TranslationProvider translations={translations} languageCode={languageCode}>
				<MuiThemeProvider theme={muiTheme}>
					<MuiPickersUtilsProvider utils={MomentUtils}>
						<ScrollToTop>
							<App history={history} />
						</ScrollToTop>
					</MuiPickersUtilsProvider>
				</MuiThemeProvider>
			</TranslationProvider>
		</ConnectedRouter>
	</Provider>,
	global.document.getElementById('app')
)

if (settings.options.enableHotReloadReducers && typeof module !== 'undefined' && typeof module.hot !== 'undefined' && typeof module.hot.accept !== 'undefined') {
	//	Ref: https://github.com/reduxjs/react-redux/releases/tag/v2.0.0
	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		module.hot.accept('./redux/reducers', () => {
			/* eslint-disable global-require */
			const nextRootReducer = require('./redux/reducers')
			store.replaceReducer(nextRootReducer)
		})
	}
}



// WEBPACK FOOTER //
// ./src/index.js